import en from '@/language/en.json'
import ar from '@/language/ar.json'
import es from '@/language/es.json'
import pt from '@/language/pt.json'
import tr from '@/language/tr.json'
import zh from '~/language/zh.json'
import th from '@/language/th.json'
import vi from '@/language/vi.json'
import inAlias from '@/language/in.json'
import fr from '@/language/fr.json'
import hi from '@/language/hi.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  messages: {
    en,
    ar,
    es,
    pt,
    tr,
    zh,
    th,
    vi,
    in: inAlias,
    fr,
    hi
  },
  warnHtmlMessage: false
}))
